import { render } from "./ProgressDialogComponent.vue?vue&type=template&id=8882a056"
import script from "./ProgressDialogComponent.vue?vue&type=script&lang=js"
export * from "./ProgressDialogComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/stephanik/platform/openmct/base/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__